import { render, staticRenderFns } from "./wahnsinn.vue?vue&type=template&id=05dbe243&scoped=true&"
import script from "./wahnsinn.vue?vue&type=script&lang=js&"
export * from "./wahnsinn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbe243",
  null
  
)

export default component.exports